import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { differenceInDays } from "date-fns";
import {
    setTheEmployeeRangetwo,
    setTheEmployeeRangeOne,
    setUserDeleteActions,
    setTheSonyEmployeeActions,
    setClientBranchSearchAction,
    setGeoLoactionStateAction,
    setZoneActions,
    setRegionActions,
    SetTheDashboardClientList,
    settheSonyEmployeeActionState,
    settheSonyEmployeeActionRegion,
    settheSonyEmployeeActionZone,
    setTheSonyEmpoyeeAction_branch,
    setthe_sony_requested_employee_list_filters,
    setTablePositionPersist,
    setthe_sony_employeee_actions_forEmployee_filter,
    setthe_sony_employeee_letter_type_filter,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import _ from "lodash";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import useDebouncedEffect from 'use-debounced-effect';
import { Employee_edit } from "./Employee_edit";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import excelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-15.svg";
import Exportpopup from "../EmployeeProfile/Exportpopup";
import RequestedPopup from "../EmployeeProfile/RequestedPopup";
import SonyPdfListPopup from "./SonyPdfListPopup";

const letterTypeOptions = [
    { value: "", label: "ALL" },
    { value: "0", label: "Appointment Letter" },
    { value: "1", label: "Salary Revision" },
    { value: "2", label: "MW Revision" },
    { value: "3", label: "Salary Structure Revision" },
    { value: "4", label: "Contract Renewal" },
    { value: "5", label: "Poor Performance" },
    { value: "6", label: "PIP" },
    { value: "7", label: "Indiscipline" },
    { value: "8", label: "Absconding" },
    { value: "9", label: "False Attendance" },
    { value: "10", label: "False Bill Submission" },
    { value: "11", label: "Transfer Letter" },
    { value: "12", label: "Relieving Letter" },
    { value: "13", label: "Experience Letter" },
    { value: "14", label: "Relinquishment Letter" },
    { value: "15", label: "Designation Change Letter" },
    { value: "16", label: "Role Change Letter" },
];

const SonyEmployeeActions = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const TablePositionPersist = useSelector(
        (state) => state.PreviousPagePosition.TablePositionPersist
    );

    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(today);
    var gt = convert(today);

    var st = convert(state.EmployeeVerificationsNeed.EmployeeRangeOne);
    var et = convert(state.EmployeeVerificationsNeed.EmployeeRangeTwo);

    const [range, setrange] = useState(
        state.EmployeeVerificationsNeed.EmployeeRangeOne == "" ? [] : [st, et]
    );
    const [dtpageindex, setdtPageindex] = useState(TablePositionPersist?.SonyEmployeeActions?.page == undefined ? 1 : TablePositionPersist.SonyEmployeeActions.page);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState(TablePositionPersist?.SonyEmployeeActions?.search == "" || TablePositionPersist?.SonyEmployeeActions?.search == undefined ? "" : TablePositionPersist.SonyEmployeeActions.search);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [DeleteID, setDeleteId] = useState();
    const [DeletePopup, setDeletePopup] = useState(false);
    const [OldEmp, setOldEMp] = useState(state?.EmployeeVerificationsNeed?.Sony_employee_actions_forEmployee_filter_old_new ? state?.EmployeeVerificationsNeed?.Sony_employee_actions_forEmployee_filter_old_new : {
        label: "NEW EMPLOYEE",
        value: false,
    });
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [nameList4, setOptions4] = useState([]);

    const [datas, setData] = useState({
        state: state.EmployeeVerificationsNeed.SonyEmployeeActionsState?.value,
        zone: state.EmployeeVerificationsNeed?.SonyEmployeeActionZone?.value,
        region: state.EmployeeVerificationsNeed.SonyEmployeeActionRegion?.value
    });

    const [records, setrecords] = useState(null);
    const [EditPopup, seteditpopup] = useState(false);
    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
    const initialDebouanceSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
        Clientsearch: ""
    };

    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
    const [exportpopup, setexportpopup] = useState(false);
    const [date_of_joining, setdate_of_joinging] = useState(null);

    const [nameList5, setOptions5] = useState([]);

    const [multiselect, setMuliselect] = useState(
        state.EmployeeVerificationsNeed.SonyEmployeeActionsState
    );
    const [multiselect1, setMuliselect1] = useState(
        state.EmployeeVerificationsNeed.SonyEmployeeActionRegion
    );
    const [multiselect3, setMuliselect3] = useState(
        state.EmployeeVerificationsNeed.SonyEmployeeActionZone
    );
    const [searchBranch, setSearch] = useState("");
    const [Client, setClients] = useState(state.EmployeeVerificationsNeed.SonyEmployeeAction_Branch ? state.EmployeeVerificationsNeed.SonyEmployeeAction_Branch?.value : "");

    const oldemloyeeOptions = [
        {
            value: true,
            label: "EXISTING EMPLOYEE",
        },
        {
            value: false,
            label: "NEW EMPLOYEE",
        },
    ];
    const [oldemplo, setoldemp] = useState({ old_employee: state?.EmployeeVerificationsNeed?.Sony_employee_actions_forEmployee_filter_old_new ? state?.EmployeeVerificationsNeed?.Sony_employee_actions_forEmployee_filter_old_new?.value : false });

    const [employee_det, setemployee_det] = useState(null);
    const form_requested_lists = [
        {
            value: true,
            label: "EMP REQUESTS",
        },
    ];
    const [requested, setrequested] = useState(
        state?.EmployeeVerificationsNeed?.Sony_requested_employee_list_filters ? state?.EmployeeVerificationsNeed?.Sony_requested_employee_list_filters : {
            label: "",
            value: "",
        });
    const [requested_emp, setrequested_emp] = useState({ is_form_requested: state?.EmployeeVerificationsNeed?.Sony_requested_employee_list_filters?.value ? state?.EmployeeVerificationsNeed?.Sony_requested_employee_list_filters?.value : "" });
    const [requestedpopup, setrequestedpopup] = useState(false);

    const [letterType, setLetterType] = useState(
        state?.EmployeeVerificationsNeed?.Sony_employee_letter_type_filter
            ? state?.EmployeeVerificationsNeed?.Sony_employee_letter_type_filter
            : []
    );
    const [pdfPopup, setPdfPopup] = useState(false);
    const [pdfModalData, setPdfModalData] = useState(null);

    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            dispatch(setTheEmployeeRangeOne(range[0]));
            dispatch(setTheEmployeeRangetwo(range[1]));
        }
        else {
            dispatch(setTheEmployeeRangeOne(""));
            dispatch(setTheEmployeeRangetwo(""));
        }
    }, [range]);

    useEffect(() => {
        const payload = {
            search: searchBranch,
            page_size: 30,
            page: 1,
            data: datas,

            organization: "5e8579aa-1ec3-42fd-925d-e8e80d501963"
        };
        dispatch(setClientBranchSearchAction(payload));
    }, [searchBranch, datas]);

    const HandleInputBranch = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
            Clientsearch: e
        });
    };

    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    //--------------Zone---------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.zoneSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            region_id: datas.region,
        };
        dispatch(setZoneActions(payloads));
    }, [datas.region, SearchedVal.zoneSearch]);

    useEffect(() => {
        if (state.ZonePart.Zone != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });

            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

    //-----Region---------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);

    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });

            state.GeoState.State.forEach((element) => {
                objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
            });
            setOptions(objectArray);
        }
    }, [state.GeoState.State, SearchedVal.stateSearch]);

    ///----------------------Region-----------
    useEffect(() => {
        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
            });
            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

    useEffect(() => {
        if (state.BranchSearchpart.BranchSearch != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.BranchSearchpart.BranchSearch.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.client_name.toUpperCase(),
                });
            });
            setOptions4(objectArray);
        }
    }, [state.BranchSearchpart.BranchSearch, searchBranch]);

    const getSelectedLetterTypeString = useCallback(() => {
        if (Array.isArray(letterType) && letterType.length > 0) {
            return letterType.map((item) => item.value).filter(Boolean).join(",");
        }
        if (letterType && typeof letterType === "object" && letterType.value) {
            return letterType.value;
        }
        return "";
    }, [letterType]);

    useEffect(() => {
        const payloads = {
            search: search,
            page_size: 20,
            page: dtpageindex,
            state: datas.state,
            region: datas.region,
            zone: datas.zone,
            client: Client,
            letter_type: getSelectedLetterTypeString(),
        };

        dispatch(setTheSonyEmployeeActions(payloads));

        dispatch(
            setTablePositionPersist({ data: payloads, pageName: "SonyEmployeeActions" })
        );
    }, [search, dtpageindex, datas, Client, letterType, getSelectedLetterTypeString]);

    //----Handle Date Changes---
    const handlechangedate = (value) => {
        setdtPageindex(1);
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };

    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last week",
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },
    ];

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const isAdminEmails =
        (state.SideBarFiles.UserEmailID == "codoid@gmail.com" ||
            state.SideBarFiles.UserEmailID == "admin@uds.in" ||
            state.SideBarFiles.UserEmailID == "admin@gmail.com" ||
            state.SideBarFiles.UserEmailID == "adminit@uds.in");

    const letterColumnsConfig = [
        { value: "0", label: "Appointment Letter", key: "appointment_letter" },
        { value: "1", label: "Salary Revision", key: "salary_revision" },
        { value: "2", label: "MW Revision", key: "mw_revision" },
        { value: "3", label: "Salary Structure Revision", key: "salary_structure_revision" },
        { value: "4", label: "Contract Renewal", key: "contract_renewal" },
        { value: "5", label: "Poor Performance", key: "poor_performance" },
        { value: "6", label: "PIP", key: "pip" },
        { value: "7", label: "Indiscipline", key: "indiscipline" },
        { value: "8", label: "Absconding", key: "absconding" },
        { value: "9", label: "False Attendance", key: "false_attendance" },
        { value: "10", label: "False Bill Submission", key: "false_bill_submission" },
        { value: "11", label: "Transfer Letter", key: "transfer_letter" },
        { value: "12", label: "Relieving Letter", key: "relieving_letter" },
        { value: "13", label: "Experience Letter", key: "experience_letter" },
        { value: "14", label: "Relinquishment Letter", key: "relinquishment_letter" },
        { value: "15", label: "Designation Change Letter", key: "designation_change_letter" },
        { value: "16", label: "Role Change Letter", key: "role_change_letter" },
    ];

    const selectedLetterValues = useMemo(() => {
        if (Array.isArray(letterType) && letterType.length > 0) {
            return letterType.map((item) => item.value).filter(Boolean);
        }
        if (letterType && typeof letterType === "object" && letterType.value) {
            return [letterType.value];
        }
        return [];
    }, [letterType]);

    const activeLetterColumnsConfig = useMemo(() => {
        if (selectedLetterValues.length > 0) {
            return letterColumnsConfig.filter((col) => selectedLetterValues.includes(col.value));
        }
        return letterColumnsConfig;
    }, [selectedLetterValues]);

    const letterColumns = useMemo(() => {
        return activeLetterColumnsConfig.map((col) => ({
            Header: col.label,
            accessor: col.key,
            Cell: (row) => {
                const pdfData = row.row.original?.[col.key];
                const pdfList = Array.isArray(pdfData) ? pdfData : [];
                const count = pdfList.length;

                if (count > 0) {
                    return (
                        <div >
                            <span
                                style={{
                                    cursor: "pointer",
                                    padding: "4px 12px",
                                    borderRadius: "12px",
                                    backgroundColor: " rgb(255, 241, 236)",
                                    color: "rgb(200, 62, 18)",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    display: "inline-block",
                                    border: "1px solid rgb(245, 185, 166)",
                                    textWrap: "nowrap"
                                }}
                                onClick={() => {
                                    setPdfModalData({
                                        title: col.label,
                                        employeeName: row.row.original?.user_id?.first_name || "--",
                                        employeeCode: row.row.original?.user_id?.employee_code || "",
                                        phoneNumber: row.row.original?.user_id?.phone_number || "",
                                        pdfList: pdfList
                                    });
                                    setPdfPopup(true);
                                }}
                                title={`Click to view ${count} ${col.label} PDF(s)`}
                            >
                                View - {count}
                            </span>
                        </div>
                    );
                }
                return (
                    <div style={{ textAlign: "center", color: "#999" }}>
                        -
                    </div>
                );
            }
        }));
    }, [activeLetterColumnsConfig]);

    const totalColumn = useMemo(() => ({
        Header: "Total",
        accessor: "total_letters_count",
        Cell: (row) => {
            let allPdfs = [];
            activeLetterColumnsConfig.forEach((col) => {
                const list = row.row.original?.[col.key];
                if (Array.isArray(list) && list.length > 0) {
                    list.forEach((item) => {
                        allPdfs.push({
                            ...item,
                            letterTypeTitle: col.label
                        });
                    });
                }
            });
            const totalCount = allPdfs.length;

            if (totalCount > 0) {
                return (
                    <div >
                        <span
                            style={{
                                cursor: "pointer",
                                padding: "4px 12px",
                                borderRadius: "12px",
                                backgroundColor: " rgb(255, 241, 236)",
                                color: "rgb(200, 62, 18)",
                                border: "1px solid rgb(245, 185, 166)",
                                fontWeight: "600",
                                fontSize: "13px",
                                display: "inline-block",
                                textWrap: "nowrap"
                            }}
                            onClick={() => {
                                setPdfModalData({
                                    title: activeLetterColumnsConfig.length < letterColumnsConfig.length ? "Selected Letters" : "All Letters",
                                    employeeName: row.row.original?.user_id?.first_name || "--",
                                    employeeCode: row.row.original?.user_id?.employee_code || "",
                                    phoneNumber: row.row.original?.user_id?.phone_number || "",
                                    pdfList: allPdfs
                                });
                                setPdfPopup(true);
                            }}
                            title={`Click to view ${totalCount} PDF(s)`}
                        >
                            View - {totalCount}
                        </span>
                    </div>
                );
            }
            return (
                <div style={{ textAlign: "center", color: "#999" }}>
                    -
                </div>
            );
        }
    }), [activeLetterColumnsConfig]);

    const columns = [

        {
            Header: "Employee Name",
            accessor: "",
            Cell: (row) => {
                const [showTooltip, setShowTooltip] = useState(false);

                return (
                    <div
                        className="UserName"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        style={{ position: 'relative', width: "150px" }}
                    >
                        {row.row.original.user_id != null &&
                            row.row.original.user_id != undefined &&
                            row.row.original.user_id?.first_name != null &&
                            row.row.original.user_id?.first_name != undefined &&
                            row.row.original.user_id?.first_name != "" ? (
                            <div className="">
                                <span>
                                    {row.row.original.user_id.first_name.length > 100 ? (
                                        <>{capitalizeFirstLetter(row.row.original.user_id.first_name.slice(0, 9))}...</>
                                    ) : (
                                        <>{capitalizeFirstLetter(row.row.original.user_id.first_name)}</>
                                    )}
                                </span>
                                {showTooltip && (
                                    <div className="custom-tooltip">
                                        {row.row.original.user_id.first_name}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <>--</>
                        )}
                    </div>
                );
            },
        },
        {
            Header: "Mobile",
            accessor: "",
            Cell: (row) => {
                const mobile = row?.row?.original?.user_id?.phone_number;
                const isActive = row?.row?.original?.user_id?.is_active;

                return (
                    <>
                        {mobile ? (
                            <div className="UserName MobileNumber">
                                <span>{isAdminEmails ? mobile : isActive ? `******${String(mobile).slice(-4)}` : mobile}</span>
                            </div>
                        ) : (
                            <div className="UserName MobileNumber">
                                <span>---</span>
                            </div>
                        )}
                    </>
                );
            },
        },




        // {
        //     Header: "Status",
        //     accessor: "",
        //     Cell: (row) => {
        //         if (row.row.original.user_id !== undefined && row.row.original.user_id !== null) {
        //             const isActive = row.row.original.user_id.is_active;
        //             const buttonStyle = {
        //                 color: isActive ? "green" : "red",
        //             };

        //             return (
        //                 <p className="p-0 m-0" style={buttonStyle}>
        //                     {isActive ? "Active" : "Inactive"}
        //                 </p>
        //             );
        //         }
        //         return "--";
        //     },
        // },
        totalColumn,
        ...letterColumns,
    ].filter(Boolean);

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 400),
        []
    );

    // -----Search------------------------
    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);
    }

    const HandleRequestedemployee = (e) => {
        setdtPageindex(1);
        if (e != null) {
            setrequested(e);
            dispatch(setthe_sony_requested_employee_list_filters(e));
            setrequested_emp({
                ...requested_emp,
                is_form_requested: e.value,
            });
        } else {
            setrequested({ value: "", label: "" });
            setrequested_emp({
                ...requested_emp,
                is_form_requested: "",
            });
            dispatch(setthe_sony_requested_employee_list_filters({ value: "", label: "" }));
        }
    };

    const HandleOldemployee = (e) => {
        setdtPageindex(1);
        setOldEMp(e);
        dispatch(setthe_sony_employeee_actions_forEmployee_filter(e));

        if (e != null) {
            setoldemp({
                ...oldemplo,
                old_employee: e.value,
            });
        }
    };

    const handleLetterTypeSelect = (selectedVal) => {
        setdtPageindex(1);
        const val = selectedVal || [];
        setLetterType(val);
        dispatch(setthe_sony_employeee_letter_type_filter(val));
    };

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const HandleSubmits = () => {
        if (DeleteID != undefined) {
            const payload = {
                DeleteID: DeleteID,
                page: dtpageindex,
                GetAPICALL: 2,
                Getapiall: {
                    search: search,
                    page_size: 20,
                    page: dtpageindex,
                    state: datas.state,
                    region: datas.region,
                    zone: datas.zone,
                    client: Client,
                    is_form_requested: requested_emp?.is_form_requested,
                    old_employee: oldemplo.old_employee,
                    letter_type: getSelectedLetterTypeString(),
                }
            };
            setsearch("");
            dispatch(setUserDeleteActions(payload, setDeletePopup(false)));
        }
    };

    const HandleClientBranches = (selectedVal) => {
        setdtPageindex(1);
        if (selectedVal != null) {
            dispatch(setTheSonyEmpoyeeAction_branch(selectedVal));
            setClients(selectedVal.value);
        } else if (selectedVal == null) {
            setClients("");
            dispatch(setTheSonyEmpoyeeAction_branch({ value: "", label: "ALL" }));
        }
    };

    //----Region----------------
    const handelRegionSlect = (selectedVal) => {
        setdtPageindex(1);
        if (selectedVal != null) {
            setMuliselect1(selectedVal);
            setMuliselect3({ value: "", label: "ALL" });

            setData({
                ...datas,
                region: selectedVal.value,
            });

            dispatch(settheSonyEmployeeActionRegion(selectedVal));
            dispatch(settheSonyEmployeeActionZone({ value: "", label: "ALL" }));
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                region: "",
                zone: "",
            });

            setMuliselect3({ value: "", label: "ALL" });
            setMuliselect1({ value: "", label: "ALL" });
            dispatch(settheSonyEmployeeActionRegion({ value: "", label: "ALL" }));
            dispatch(settheSonyEmployeeActionZone({ value: "", label: "ALL" }));
        }
    };

    //----------------Zone
    const handleZone = (selectedVal) => {
        setdtPageindex(1);
        if (selectedVal != null) {
            setMuliselect3(selectedVal);
            setData({
                ...datas,
                zone: selectedVal.value,
            });

            dispatch(settheSonyEmployeeActionZone(selectedVal));
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                zone: "",
            });

            setMuliselect3({ value: "", label: "ALL" });
            dispatch(settheSonyEmployeeActionZone({ value: "", label: "ALL" }));
        }
    };

    const handleSelectChange = (selectedVal) => {
        setdtPageindex(1);
        dispatch(setTheSonyEmpoyeeAction_branch({ value: "", label: "ALL" }));

        if (selectedVal != null) {
            setMuliselect(selectedVal);
            setMuliselect1({ value: "", label: "ALL" });
            setMuliselect3({ value: "", label: "ALL" });

            setData({
                ...datas,
                state: selectedVal.value,
                region: "",
                zone: "",
            });

            dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
            setClients("");

            dispatch(settheSonyEmployeeActionState(selectedVal));
            dispatch(settheSonyEmployeeActionRegion({ value: "", label: "ALL" }));
            dispatch(settheSonyEmployeeActionZone({ value: "", label: "ALL" }));
        }
        if (selectedVal == null) {
            setMuliselect({ value: "", label: "ALL" });
            setMuliselect1({ value: "", label: "ALL" });
            setMuliselect3({ value: "", label: "ALL" });
            setData({
                ...datas,
                state: "",
                zone: "",
                region: "",
            });
            dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
            setClients("");

            dispatch(settheSonyEmployeeActionState({ value: "", label: "ALL" }));
            dispatch(settheSonyEmployeeActionRegion({ value: "", label: "ALL" }));
            dispatch(settheSonyEmployeeActionZone({ value: "", label: "ALL" }));
        }
    };

    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    stateSearch: SearchDebounance.stateSearch,
                    regionSearch: SearchDebounance.regionSearch,
                    zoneSearch: SearchDebounance.zoneSearch,
                });
                setSearch(SearchDebounance.Clientsearch);
            }
        },
        500,
        [SearchDebounance]
    );

    ///-----State Input Changes
    const handleInputChange = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            stateSearch: Val,
        });
    };

    ///---Region-----------------
    const handleInputRegion = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            regionSearch: Val,
        });
    };

    ///----Zone Name
    const handleInputZone = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            zoneSearch: Val,
        });
    };

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage);
    };

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        className="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3 className="user-name mb-0">Sony Employees </h3>
                    </div>
                </div>
                <div
                    className="row Filters"
                    style={{
                        padding: "15px 28px",
                        marginLeft: "0px",
                        marginRight: "0px",
                        marginTop: "0px "
                    }}
                >
                    <div
                        className="col-sm-2"
                        style={{ marginTop: "-19px", zIndex: "99" }}
                    >
                        <label
                            htmlFor="validationCustom01"
                            className="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            State
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => {
                                setMuliselect(e);
                            }}
                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            onremoved={(e) => {
                                setMuliselect({ value: "", label: "All" });
                            }}
                            value={multiselect}
                            labelledBy="Select"
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
                        <label
                            htmlFor="validationCustom01"
                            className="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Region
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect1(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            htmlFor="validationCustom01"
                            className="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Zone
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect3(e);
                            }}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div>

                    <div
                        className="col-sm-2"
                        style={{ zIndex: "20", marginTop: "-19px" }}
                    >
                        <label
                            htmlFor="validationCustom01"
                            className="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Client
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                setdtPageindex(1);
                                if (dtpageindex == 1) {
                                    HandleClientBranches(e);
                                }
                            }}
                            filterOption={() => true}
                            options={nameList4}
                            labelledBy="Select"
                            onInputChange={HandleInputBranch}
                            isClearable={true}
                            value={state.EmployeeVerificationsNeed.SonyEmployeeAction_Branch}
                        />
                    </div>

                    <div
                        className="col-sm-2"
                        style={{ zIndex: "15", marginTop: "-19px" }}
                    >
                        <label
                            htmlFor="validationCustom01"
                            className="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Letter Type
                        </label>
                        <Select
                            className="Selects"
                            isMulti={true}
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => handleLetterTypeSelect(e)}
                            options={letterTypeOptions.filter((opt) => opt.value !== "")}
                            isClearable={true}
                            value={letterType}
                            labelledBy="Select"
                            placeholder={"Select Letter Type"}
                        />
                    </div>
                </div>

                <div className="sony-employee-table" style={{ marginTop: "-13px" }}>
                    {/* many letter columns: keep cells on one line, scroll sideways inside the table, pagination stays fixed (same as the Employee tab) */}
                    <style>{`
                        .sony-employee-table { padding: 30px 40px; max-width: 100%; box-sizing: border-box; }
                        .sony-employee-table .table-responsive { overflow-x: auto; container-type: inline-size; -webkit-overflow-scrolling: touch; }
                        .sony-employee-table .INNERTABLE { width: max-content; min-width: 100%; }
                        .sony-employee-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
                        .sony-employee-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
                        .sony-employee-table .TableDesgin { min-width: 100%; }
                        .sony-employee-table .TableDesgin th {
                            width: auto !important;
                            white-space: nowrap;
                            vertical-align: middle;
                            padding: 12px 14px !important;
                        }
                        .sony-employee-table .TableDesgin td {
                            white-space: nowrap;
                            vertical-align: middle;
                            padding: 12px 14px !important;
                        }
                        .sony-employee-table .TableDesgin td p { margin: 0; }
                        /* Total + letter columns (3rd column onwards) centred */
                        .sony-employee-table .TableDesgin th:nth-child(n+3),
                        .sony-employee-table .TableDesgin td:nth-child(n+3) { text-align: center; }
                        @media (max-width: 991px) {
                            .sony-employee-table { padding: 20px 20px; }
                        }
                        @media (max-width: 575px) {
                            .sony-employee-table { padding: 16px 10px; }
                            .sony-employee-table .TableDesgin th,
                            .sony-employee-table .TableDesgin td { padding: 10px 10px !important; font-size: 13px; }
                        }
                    `}</style>
                    <ReactTable
                        data={state.SonyEmployeeCalls?.SonyEmployeeDatas || []}
                        columns={columns}
                        totalItems={state.SonyEmployeeCalls?.Total_count || 0}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        pageindex={pageindex}
                        datacount={state.SonyEmployeeCalls?.Total_count || 0}
                        Filter={true}
                        NoFilter={true}
                        searchVal={TablePositionPersist?.SonyEmployeeActions?.search == "" || TablePositionPersist?.SonyEmployeeActions?.search == undefined ? "" : TablePositionPersist.SonyEmployeeActions.search}
                        search_key={true}
                        nostatusFilter={true}
                    />
                </div>
            </div>

            {DeletePopup ? (
                <Delete
                    show={DeletePopup}
                    setShow={setDeletePopup}
                    onSubmit={HandleSubmits}
                    Content={"Do you want to delete the Employee"}
                />
            ) : null}
            {EditPopup && (
                <Employee_edit
                    show={EditPopup}
                    setshow={seteditpopup}
                    employee={records}
                    passingpayloads={{
                        search: search,
                        page_size: 20,
                        page: dtpageindex,
                        old_employee: oldemplo.old_employee,
                        state: datas.state,
                        region: datas.region,
                        zone: datas.zone,
                        client: Client,
                        letter_type: letterType?.value !== undefined && letterType?.value !== null ? letterType.value : "",
                    }}
                />
            )}

            {exportpopup && (
                <Exportpopup
                    setshow={setexportpopup}
                    show={exportpopup}
                    id={records}
                    date_of_joining={date_of_joining}
                />
            )}

            {requestedpopup && (
                <RequestedPopup
                    setshow={setrequestedpopup}
                    show={requestedpopup}
                    id={records}
                    date_of_joining={date_of_joining}
                    user_details={employee_det}
                />
            )}

            {pdfPopup && pdfModalData && (
                <SonyPdfListPopup
                    show={pdfPopup}
                    setshow={setPdfPopup}
                    modalData={pdfModalData}
                />
            )}
        </>
    );
};

export default SonyEmployeeActions;